export default {
  contentHotelInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '@global > button': {
      margin: '0 20px'
    },
  },
  hotelTitle: {
    font: "400 16px 'Roboto'",
    display: 'block',
    marginBottom: '3px',
    '@media (min-width: 801px)': {
      fontSize: '24px',
    }
  },
  hotelAdress: {
    font: "300 13px 'Roboto'",
    color: '#666666'
  }
};

